import React from 'react';

import { useBrandContext } from '~/brands/BrandContext';
import { ReactComponent as NonStyledLogo } from '~/overwrites/assets/logo.svg';

const BrandLogo = () => {
  const { brand } = useBrandContext();
  return <>{brand?.logo || <NonStyledLogo />}</>;
};

export default BrandLogo;
